import { Injectable, inject } from '@angular/core';
import { Auth } from '../core/firebase/auth';

@Injectable({
  providedIn: 'root',
})
export class SettingService {
  private auth = inject(Auth);

  userHasEmailAuthProvider() {
    const providers = this.auth.currentUser?.providerData;

    return (
      providers?.some(provider => provider.providerId === 'password') ?? false
    );
  }
}
